import axios from "axios";
// import { keyDeErrorApi } from "../../_comun/reductores/Constantes";
// import { StatusCodes } from "http-status-codes";
import * as Error from "../isp._comun/services/Errores";
import ServiceAPI from "../isp._comun/services/ServiceAPI";

export default class ServiceQueryUnServicio extends ServiceAPI{

    async hacerRequerimientoAxios(idItemPorConsultar) {
        const baseUrl =
            process.env.REACT_APP_API_SERVER +
            "/items/" +
            idItemPorConsultar;
        const respAxios = await axios({
            method: "get",
            url: baseUrl,
            data: null,
            headers: {
                "Content-Type": "application/json",
                // "Access-Control-Allow-Origin": "*",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
            signal: this.controller.signal
        });
        return respAxios;
    }

    getDataDeRespuestaAxiosExitosa(respAxiosExito){
        const respuestaApi = respAxiosExito.data;

        let dataDeActualizacionDeCliente;
        try {
            //parsear respuestaApi de tal manera que la data tenga el formato de exito correcto
            //Si hay error en parseo:
            // throw new ErrorDeApp.ErrorFormatoDeCom();
            dataDeActualizacionDeCliente = respuestaApi.data;
        } catch (error) {
            throw new Error.ErrorDeProtocoloDelServidor();
        }
        return dataDeActualizacionDeCliente;
    }

    lanzarErrorDeRespuestaAxiosErroneaDelComando(errorAxios) {}
}
// export default ServicioDeQueryDeUnClienteAFacturar ;
